<template>
  <v-container class="pt-4 pb-0 pb-md-4" :class="{ 'sidebyside': sideinfo }">
    <v-layout row align-start wrap>
      <v-flex class="content px-4 pb-4 pb-md-0">
        <div class="headline mb-2">
          <slot name="title"></slot>
        </div>
        <div>
          <slot name="content"></slot>
        </div>
        <v-spacer></v-spacer>
        <div class="actions mt-9 d-flex align-center">
          <slot name="actions"></slot>
        </div>
      </v-flex>
      <v-flex v-if="sideinfo" class="sideinfo py-4 pl-4">
        <v-layout column fill-height>
          <div v-if="!selected" class="empty text-center text-uppercase grey--text hidden-sm-and-down">
            <div>
              <slot name="empty"></slot>
            </div>
          </div>
          <template v-else>
            <div class="title secondary--text text-uppercase headline pb-0">
              <slot name="selection"></slot>
            </div>
            <div class="pr-0 pb-2 fill-height component-selection">
              <v-tabs background-color="transparent">
                <slot name="info"></slot>
              </v-tabs>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    /**
     * Whether an item is currently selected or not.
     */
    selected: Boolean,
    sideinfo: Boolean
  }
}
</script>

<style lang="scss" scoped>
.content {
  flex: 1 1 100%;
}

.actions button ~ button {
  margin-left: 1rem;
}

.component-selection {
  overflow: hidden;
}

.sideinfo {
  background: var(--v-secondary-lighten4);
  box-sizing: content-box;
  margin-top: -2px;
  padding-top: 2px;

  .v-card__title {
    flex: 0 0 auto;

    &:empty {
      display: none;
    }
  }

  .v-card__text {
    flex: 1 1 100%;
    overflow: hidden;
    width: auto;
  }

  .v-tabs {
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
  }

  ::v-deep .v-tabs-bar {
    flex: 0 0 auto;
    margin-bottom: 2px;
  }

  ::v-deep .v-tabs-slider {
    color: var(--v-accent-base);
  }

  ::v-deep .v-window {
    background: transparent;
    flex: 1 1 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 16px;
  }
}

@media (min-width: 960px) {
  .sidebyside {
    .content {
      flex: 1 1 60%;
      max-width: 60%;
      width: 60%;
    }

    .sideinfo {
      bottom: 0;
      box-sizing: border-box;
      position: absolute;
      right: 0;
      top: 0;
      width: 40%;
    }

    .empty {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
    }
  }
}
</style>
